var map = {
	"./ICBC.jpg": 73202,
	"./PDF.png": 21529,
	"./activity-left.png": 15600,
	"./activity-right.png": 47621,
	"./activity.png": 86156,
	"./addressIcon.png": 32536,
	"./avatar.png": 75536,
	"./beian.png": 34014,
	"./bjhailiang.jpg": 74354,
	"./bjhailiang.png": 69398,
	"./cnMobie.png": 89578,
	"./cndianzi.png": 8131,
	"./cnhualu.png": 12149,
	"./cnmobeil.png": 83796,
	"./cnmobeil.webp": 28809,
	"./cnruanjian.png": 52020,
	"./code.jpg": 54256,
	"./committee.png": 15572,
	"./committeeBg.png": 89401,
	"./cyjsIcon.png": 45801,
	"./cyqyIcon.png": 13338,
	"./detailBanner.png": 55370,
	"./dialogClose.png": 56175,
	"./emailIcon.png": 80096,
	"./footer-logo.png": 54716,
	"./gyhxxhb.png": 1093,
	"./gzszIcon.png": 52880,
	"./header_bg.png": 78384,
	"./home_banner.png": 57929,
	"./huawei.jpg": 98992,
	"./hydtIcon.png": 44165,
	"./icon_notice.png": 11389,
	"./icon_query.png": 20465,
	"./index.png": 53015,
	"./indexNoDate.jpg": 61506,
	"./link-icon.png": 5945,
	"./link2.png": 96945,
	"./link3.png": 48552,
	"./link4.png": 28167,
	"./link5.png": 52382,
	"./lnzzIcon.png": 41966,
	"./logo.png": 82806,
	"./logoTitle.png": 83398,
	"./nav-list-1.png": 20917,
	"./nav_active.png": 87459,
	"./newsBg.png": 34323,
	"./noUnit.png": 38972,
	"./organizationalStru.png": 47347,
	"./os.png": 81237,
	"./query_01.png": 53585,
	"./query_02.png": 77338,
	"./query_03.png": 67171,
	"./scbk.png": 32692,
	"./scbkIcon.png": 27427,
	"./search-icon-1.png": 73311,
	"./shuguang.jpg": 2053,
	"./sqjrIcon.png": 59892,
	"./technology1.png": 70656,
	"./technology2.png": 68219,
	"./technology3.png": 46674,
	"./technologyBg.png": 66428,
	"./temp/200x150.png": 59100,
	"./temp/626x430.png": 8967,
	"./temp/image 7.png": 80076,
	"./temp/logo-1.png": 89049,
	"./temp/logo.png": 35375,
	"./title-left.png": 43663,
	"./title-right.png": 77344,
	"./unitBg.png": 93200,
	"./word.png": 64931,
	"./word_icon.png": 57755,
	"./wx.jpeg": 96327,
	"./wyhIcon.png": 11132,
	"./xinsheng.png": 6115,
	"./xjclBg.png": 84453,
	"./zcxwIcon.png": 44402,
	"./zlk.png": 96694,
	"./zlkIcon.png": 13001,
	"./zszl.png": 56560,
	"./zszlIcon.png": 30911,
	"./zszq.png": 3893,
	"./zszqIcon.png": 88206,
	"./zwxwIcon.png": 27638,
	"./zzjgIcon.png": 63337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;